import { US1_TEST2_HOSTS } from '@fleet/environment';
import { FLEET_VERSION } from '@fleet/version';

export const environment = {
  production: true,
  hmr: false,
  version: FLEET_VERSION,
  minTokenExpiry: 60,
  fleetProduct: 'TRAVELLER',
  envName: 'test2-us1',

  ...US1_TEST2_HOSTS,
};
